<div #page class="page-layout simple fullwidth">
    <!-- HEADER -->
    <div class="header p-24 h-64 grey-100 mt-24" fxLayout="row" fxLayoutAlign="space-between center">
        <div fxLayout="row" fxLayoutAlign="start center">
            <div fxLayout="column" fxLayoutAlign="start start" *fuseIfOnDom [@animate]="{
                    value: '*',
                    params: { delay: '100ms' }
                }">
                <div class="h2">{{ 'home.title' | translate }}</div>
            </div>
        </div>
    </div>
    <!-- / HEADER -->
    
    <!-- CONTENT -->
    <div class="content p-24" *ngIf="features.includes('case')">
        <div >
            <form fxLayout="column"
            fxLayoutGap="4px"
            [formGroup]="form"
            autocomplete="off">
                <mat-form-field appearance="outline" fxFlex class="float-right">
                    <mat-label>Departments</mat-label>
                    <mat-select formControlName="departmentsField" (selectionChange)="setDepartment($event.value)">
                        <mat-option *ngFor="let department of departments" [value]="department.id">
                            <div>{{ department.name }}</div>
                        </mat-option>
                    </mat-select>
                    <button color="primary" type="button" mat-button matSuffix mat-icon-button aria-label="Clear"
                        *ngIf="form.get('departmentsField').value" 
                        (click)="$event.stopPropagation(setDepartment($event.value)); form.get('departmentsField').setValue('')">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
            </form> 

        </div>
        
        <div fxLayout="row wrap">
                      
            <mat-card class="case-count-card bg-blue">
                <mat-card-title >{{caseCount.new}}</mat-card-title>
                <mat-card-content>{{"home.new_requests" | translate}}</mat-card-content> 
            </mat-card>
            
            <mat-card class="case-count-card bg-blue">
                <mat-card-title >{{caseCount.reassigned}}</mat-card-title>
                <mat-card-content>{{"home.reassigned_requests" | translate}}</mat-card-content> 
            </mat-card>

            <mat-card class="case-count-card bg-cyan">
                <mat-card-title>{{caseCount.acknowledged}}</mat-card-title>
                <mat-card-content>{{"home.acknowledged_requests" | translate}}</mat-card-content>
            </mat-card>

            <mat-card class="case-count-card bg-yellow">
                <mat-card-title>{{caseCount.in_progress}}</mat-card-title>
                <mat-card-content>{{"home.in_progress_requests" | translate}}</mat-card-content>                
            </mat-card>

            <mat-card class="case-count-card bg-warn">
                <mat-card-title>{{caseCount.escalated}}</mat-card-title>
                <mat-card-content>{{"home.escalated_requests" | translate}}</mat-card-content>
            </mat-card>


            <mat-card class="case-count-card bg-green">
                <mat-card-title>{{caseCount.resolved}}</mat-card-title>
                <mat-card-content>{{"home.resolved_requests" | translate}}</mat-card-content>
            </mat-card>
            

            <!-- <span class="hint-text h3">{{ 'home.empty_message' | translate }}</span> -->
        </div>
    </div>
    <!-- / CONTENT -->
</div>